import styled, { createGlobalStyle, css } from 'styled-components'

import GameArea from './components/GameArea'
import Words from './components/Words'
import { GameProvider } from './context'

const GlobalStyle = createGlobalStyle`
	/* colors */
	:root {
		${props =>
      props.darkMode
        ? css`
            --clr-background: #111;
            --clr-primary: #59a9ff;
            --clr-square: #303030;
            --clr-square-active: #1f2e40;
            --clr-border: #4a4a4a;
            --clr-text: white;
            --clr-highlight: #222;
            --clr-overlay: rgba(60, 60, 60, 0.7);
          `
        : css`
            --clr-background: #f7f7f7;
            --clr-primary: #007bff;
            --clr-square: white;
            --clr-square-active: #e0efff;
            --clr-border: #ddd;
            --clr-text: #444;
            --clr-highlight: #e9e9e9;
            --clr-overlay: rgba(0, 0, 0, 0.5);
          `}
	}
`

const StyledApp = styled.div`
  height: 100%;
  // overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  align-items: start;

  @media screen and (min-width: 661px) {
    flex-wrap: nowrap;
  }
`

const WordHuntGame = ({ wordsList, showWords, onComplete, onError }) => (
  <GameProvider
    wordsList={wordsList}
    showWords={showWords}
    onComplete={onComplete}
    onError={onError}
  >
    <GlobalStyle />
    <StyledApp>
      <Words />
      <GameArea />
    </StyledApp>
  </GameProvider>
)

export { WordHuntGame }
